// For exploremore button in PLP and main search page
// script is in am-plp.liquid and main-search.liquid

function loadMore(moreURL) {
    if (moreURL.length) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', moreURL, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                var data = xhr.responseText;
                var parser = new DOMParser();
                var parsedData = parser.parseFromString(data, 'text/html');
                var productList = document.querySelector('.am-explorebutton-collection');
                const showLoadMoreButton = parsedData.querySelector('#nextLoad')
                const loadMoreButton = document.querySelector('#nextLoad')
                const currentProductCount = document.getElementsByClassName('am-plp-grid__grid__item ');
                const nextProductCount = parsedData.getElementsByClassName('am-plp-grid__grid__item ');
                let currentlyAvailableProduct = document.querySelector(".am-current__product-count");
                currentlyAvailableProduct.innerHTML = currentProductCount.length + nextProductCount.length;
                if (showLoadMoreButton) {
                    loadMoreButton.replaceWith(showLoadMoreButton)
                }
                else {
                    let current = document.getElementsByClassName("am-current__product-count")
                    let total = document.getElementsByClassName("am-total__product-count")
                    let difference = total - current;
                    if (current < difference)
                        current.innerHTML += current.innerHTML
                    else
                        current.innerHTML = total.innerHTML

                    loadMoreButton.remove()
                }
                if (productList) {
                    var gridProducts = productList.querySelector('.product-grid__items');

                    if (gridProducts) {
                        gridProducts.insertAdjacentHTML('beforeend', parsedData.querySelector('.collection .product-grid__items').innerHTML);
                    }
                }
                updatePrices();
            }
        };
        xhr.send();
    }
}

window.onclick = function (event) {
    if (event.target.id === 'nextLoad') {
        event.preventDefault();
        console.log('Clicked on element with ID "nextLoad". Calling your function...');

        const loadMoreLinks = document.querySelector('a.loadMore');
        loadMoreLinks.style.opacity = "0.5";
        loadMoreLinks.style.pointerEvents = "none";
        var moreURL = loadMoreLinks.getAttribute('href');
        loadMore(moreURL);
    }
};
